import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'Login',
            hidden: true,
            component: require('@views/Login.vue').default
        },
        {
            path: '/home',
            name: '订单',
            component: require('@views/Home.vue').default,
            children: [
                {
                    path: '/home/orderlist',
                    name: '订单列表',
                    component: require('@views/order/Orderlist.vue').default,
                },
                {
                    path: '/home/orderdetail_',
                    name: '订单详情_',
                    component: require('@views/order/Orderdetail_.vue').default
                },
                {
                    path: '/home/orderdetail_A',
                    name: '订单详情_A',
                    component: require('@views/order/Orderdetail_A.vue').default
                },
                {
                    path: '/home/orderdetail_B',
                    name: '订单详情_B',
                    component: require('@views/order/Orderdetail_B.vue').default
                },
                {
                    path: '/home/productlist',
                    name: '商品列表',
                    component: require('@views/order/productlist.vue').default
                },
                {
                    path: '/home/productlist_A',
                    name: '商品列表A',
                    component: require('@views/order/productlist_A.vue').default
                },
                {
                    path: '/home/productlist_B',
                    name: '商品列表B',
                    component: require('@views/order/productlist_B.vue').default
                },
                {
                    path: '/home/search',
                    name: '搜索',
                    component: require('@views/order/search.vue').default
                },
                {
                    path: '/home/search_',
                    name: '搜索_',
                    component: require('@views/order/search_.vue').default
                },
                {
                    path: '/home/search_A',
                    name: '搜索_A',
                    component: require('@views/order/search_A.vue').default
                },
                {
                    path: '/home/search_B',
                    name: '搜索_B',
                    component: require('@views/order/search_B.vue').default
                },
                {
                    path: '/home/trace',
                    name: '追踪订单',
                    component: require('@views/order/trace.vue').default
                },
                {
                    path: '/home/log',
                    name: '操作记录',
                    component: require('@views/order/log.vue').default
                }
            ]
        }
    ]
})
